<div [hidden]="!show" class="boundary free-dragging-modal-container">
  <div class="box" appFreeDragging appFreeDraggingHandle>
    <button type="button" class="close" (click)="closeModal()">&times;</button>
    <div class="header-container">
      <div id="rangeTitleContainer">
        <p id="rangesModalTitle"><b> Valid Ranges </b></p>
        <div id="alertIcon" class="swal2-icon swal2-warning swal2-icon-show">
          <div class="swal2-icon-content" style="font-size: 1.75em">!</div>
        </div>
      </div>
    </div>
    <div class="row body-container">
      <div class="col-md-6">
        <p class="sub-title"><b>Pipe</b></p>
        <p>
          Outside Diameter ({{ outsideDiameterUnit }}): {{ outsideDiameterMin }} -
          {{ outsideDiameterMax }}
        </p>
        <p>
          Wall Thickness ({{ wallThicknessUnit }}): {{ wallThicknessMin }} -
          {{ wallThicknessMax }}
        </p>
        <p>Min Wall Thickness (%): {{ minWallThicknessMin }} - {{ minWallThicknessMax }}</p>
        <p class="sub-title" style="margin: 15px 0;"><b>Properties</b></p>
        <p>
          Max Flaw Size ({{ maxFlawSizeUnit }}): {{ maxFlawSizeMin }} -
          {{ maxFlawSizeMax }}
        </p>
        <p>Material Toughness: {{ materialToughnessMin }} - {{ materialToughnessMax }}</p>
        <p>Ovality (%): {{ ovalityMin }} - {{ ovalityMax }}</p>
        <p>Eccentricity (%): {{ eccentricityMin }} - {{ eccentricityMax }}</p>
        <p>
          Residual Stresses: {{ residualStressMin }} -
          {{ residualStressMax }}
        </p>
      </div>
      <div class="col-md-6">
        <p class="sub-title"><b>Material</b></p>
        <p>SMYS ({{ smysUnit }}): {{ smysMin | number: getSmysDecimalPlaces() }} - {{ smysMax | number: getSmysDecimalPlaces() }}</p>
        <p>UTS ({{ utsUnit }}): {{ utsMin | number: getUtsDecimalPlaces() }} - {{ utsMax | number: getUtsDecimalPlaces() }}</p>
        <p>
          Young Modulus E ({{ youngModulusUnit }}): {{ youngModulusMin }} -
          {{ youngModulusMax }}
        </p>
        <p>Poisson Ratio: {{ poissonRatioMin }} - {{ poissonRatioMax }}</p>
        <p class="sub-title" style="margin: 15px 0;"><b>Loads</b></p>
        <p>
          Internal Pressure ({{ internalPressureUnit }}): ≥ {{ internalPressureMin }}
        </p>
        <p>
          External Pressure ({{ externalPressureUnit }}): ≥ {{ externalPressureMin }}
        </p>
      </div>
    </div>
  </div>
</div>